export const clarification_alert =  `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 493.498 493.498" style="enable-background:new 0 0 493.498 493.498;" xml:space="preserve">
<g>
<path d="M322.999,207.495c7.888,7.887,19.99,8.979,29.053,3.289l-32.343-32.343C314.02,187.504,315.111,199.606,322.999,207.495z"
   />
<path d="M339.927,128.019c-10.118-2.287-20.751,0.778-28.087,8.112l-0.705,0.706c-6.184,6.184-6.184,16.209,0,22.393l95.369,95.367
   c6.184,6.185,16.209,6.185,22.393,0l0.705-0.705c7.346-7.346,10.403-17.953,8.113-28.086c-1.938-8.575,0.43-17.926,7.105-24.602
   l27.478-27.479c18.139-18.139,21.428-45.494,9.889-66.987l6.593-6.591c4.003-4.004,4.003-10.494,0-14.498l-8.698-8.697
   c-4.004-4.004-10.494-4.004-14.497,0l-6.593,6.592c-21.492-11.539-48.847-8.249-66.984,9.89l-27.479,27.479
   C357.853,127.589,348.502,129.958,339.927,128.019z"/>
<path d="M489.977,191.405l-28.674,27.479l-0.434,151.723c0,2.574-0.724,4.923-1.792,7.09L343.74,262.35l17.58-17.58l-7.535-7.535
   c-4.575,1.4-9.355,2.128-14.202,2.128c-5.614,0-11.081-0.951-16.221-2.771l-71.579,71.579c-2.691,2.691-7.377,2.691-10.068,0
   L62.667,129.115h223.474c1.869-3.581,4.302-6.94,7.305-9.943l0.719-0.72c10.284-10.281,24.534-16.177,39.098-16.177
   c4.091,0.001,8.188,0.458,12.178,1.359c0.114,0.026,0.234,0.039,0.355,0.039c0.619,0,0.938-0.317,1.057-0.438l6.749-6.749H48.942
   C21.954,96.487,0,118.44,0,145.428v225.178c0,26.987,21.954,48.941,48.942,48.941h395.613c26.988,0,48.942-21.954,48.942-48.941
   v-182.97C492.363,188.919,491.199,190.182,489.977,191.405z M34.413,377.696c-1.061-2.167-1.784-4.516-1.784-7.09V145.428
   c0-0.063,0.031-0.11,0.031-0.174L149.758,262.35L34.413,377.696z M71.326,386.919L172.827,285.42l45.817,45.819
   c7.514,7.511,17.494,11.646,28.104,11.646c10.61,0,20.591-4.135,28.104-11.646l45.818-45.819l101.491,101.499H71.326z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
`;